import axios from "axios";
import { ToastDanger } from "../../components/common/Toast";

export const axiosInterCeptors = axios.create();

axiosInterCeptors.interceptors.request.use(
  (req: any) => {
    req.headers = {
      Authorization: localStorage.getItem("token")
        ? `Bearer ${localStorage.getItem("token")}`
        : "",
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInterCeptors.interceptors.response.use(
  (res: any) => {
    return res;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      // window.location.reload();
    }
    return Promise.reject(error);
  }
);
